import React, { useState, useEffect } from 'react';

const LoadingOverlay = ({ 
  message = "Processing your order...",
  showProgress = false 
}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (showProgress) {
      const timer = setInterval(() => {
        setProgress(prev => {
          if (prev >= 90) {
            clearInterval(timer);
            return prev;
          }
          return prev + 10;
        });
      }, 500);

      return () => clearInterval(timer);
    }
  }, [showProgress]);

  return (
    <div 
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        zIndex: 9999,
        backdropFilter: 'blur(3px)',
      }}
    >
      <div className="text-center text-white p-4 rounded bg-primary" >
        <div className="spinner-border text-light mb-3" style={{ width: '3rem', height: '3rem' }} role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        
        <h5 className="mt-2 mb-3">{message}</h5>
        
        {showProgress && (
          <div className="progress mb-3" style={{ height: '6px', width: '200px', margin: '0 auto' }}>
            <div 
              className="progress-bar progress-bar-striped progress-bar-animated" 
              role="progressbar"
              style={{ width: `${progress}%` }}
              aria-valuenow={progress}
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        )}
        
        <p className="text-light mb-0 small">
          Please don't close this window...
        </p>
      </div>
    </div>
  );
};

export default LoadingOverlay;